import axios from "axios";
let eventosTabla = {
  nom: { label: "Estación", skill: ["text"], asset: "", prefix: "", sufix: "" },
  cod: { label: "Código", skill: ["number"], asset: "", prefix: "", sufix: "" },
  pos: {
    label: "Ubicación",
    skill: ["geoJSON"],
    asset:
      "La latitud, nos indica la distancia angular entre la línea ecuatorial y un punto cualquiera sobre la Tierra. Define una de las coordenadas en grados del epicentro. La longitud, indica la distancia angular entre un punto cualquiera sobre la superficie de la Tierra y el meridiano que se tome como 0°. Define una de las coordenadas en grados del epicentro.",
    prefix: "",
    sufix: ""
  }
};
let fakeStations = {
  _id: { $date: { $numberLong: "1615444535000" } },
  event: {
    fec: { $date: { $numberLong: "1615444535000" } },
    pos: { type: "Point", coordinates: [-74.63, -15.46] },
    mag: 4.7,
    pro: 56,
    num: 20210133,
    inte: "III  Pinchollo",
    ref: "49 km al N de Madrigal, Caylloma - Arequipa"
  },
  stats: [
    {
      cod: "SCTAC",
      net: "SC",
      nom: "SENCICO TACNA",
      order: 1,
      pos: {type: "Point", coordinates: [-70.24, -17.9923]},
      type: "Point",
      typ: "acc",
    },
    {
      cod: "LYAR",
      net: "PE",
      nom: "LA YARADA",
      order: 2,
      pos: {type: "Point", coordinates: [-70.57, -18.1412]},
      type: "Point",
      typ: "sis",
    }
  ]
};
let fakeEventos = {
  events: [
    {
      fec: "29-06-2020 02:42:26",
      pos: { type: "Point", coordinates: [-72.03, -15.89] },
      pro: 123,
      mag: 4.3,
      val: "20200629_024226",
      inte: null,
      num: 20200445,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "15-03-2022 06:17:00",
      pos: {type: "Point", coordinates: [-76.83, -11.46]},
      pro: 101,
      mag: 5.2,
      val: "20220315_111700",
      inte: "III  Canta",
      num: 20220150,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "28-06-2020 13:37:22",
      pos: { type: "Point", coordinates: [-75, -8.01] },
      pro: 150,
      mag: 4.8,
      val: "20200628_133722",
      inte: null,
      num: 20200443,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "25-06-2020 06:48:00",
      pos: { type: "Point", coordinates: [-73.41, -16.26] },
      pro: 22,
      mag: 4,
      val: "20200625_064800",
      inte: "III  Atico",
      num: 20200440,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "25-06-2020 06:20:18",
      pos: { type: "Point", coordinates: [-71.86, -15.65] },
      pro: 8,
      mag: 3.4,
      val: "20200625_062018",
      inte: "III  Pinchollo",
      num: 20200439,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "24-06-2020 08:54:51",
      pos: { type: "Point", coordinates: [-70.52, -17.76] },
      pro: 21,
      mag: 3.5,
      val: "20200624_085451",
      inte: null,
      num: 20200438,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "23-06-2020 09:01:18",
      pos: { type: "Point", coordinates: [-81.23, -6.21] },
      pro: 39,
      mag: 4.1,
      val: "20200623_090118",
      inte: null,
      num: 20200437,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "22-06-2020 13:08:57",
      pos: { type: "Point", coordinates: [-81.58, -6.07] },
      pro: 32,
      mag: 5.1,
      val: "20200622_130857",
      inte: null,
      num: 20200436,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "22-06-2020 04:10:21",
      pos: { type: "Point", coordinates: [-77.91, -11.32] },
      pro: 40,
      mag: 3.9,
      val: "20200622_041021",
      inte: null,
      num: 20200435,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "22-06-2020 01:15:35",
      pos: { type: "Point", coordinates: [-73.42, -14.13] },
      pro: 97,
      mag: 4,
      val: "20200622_011535",
      inte: "--",
      num: 20200434,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "21-06-2020 17:35:26",
      pos: { type: "Point", coordinates: [-78.69, -6.76] },
      pro: 18,
      mag: 3.6,
      val: "20200621_173526",
      inte: "III  Bambamarca",
      num: 20200433,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "21-06-2020 14:18:00",
      pos: { type: "Point", coordinates: [-74.79, -10.82] },
      pro: 16,
      mag: 3.9,
      val: "20200621_141800",
      inte: "III  Satipo",
      num: 20200432,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "21-06-2020 10:27:16",
      pos: { type: "Point", coordinates: [-77.41, -11.71] },
      pro: 76,
      mag: 3.6,
      val: "20200621_102716",
      inte: null,
      num: 20200431,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "20-06-2020 14:39:12",
      pos: { type: "Point", coordinates: [-71.88, -15.66] },
      pro: 10,
      mag: 3.6,
      val: "20200620_143912",
      inte: "III  Pinchollo",
      num: 20200430,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "18-06-2020 09:15:45",
      pos: { type: "Point", coordinates: [-71.86, -15.63] },
      pro: 12,
      mag: 3.5,
      val: "20200618_091545",
      inte: "III  Pinchollo",
      num: 20200429,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    },
    {
      fec: "18-06-2020 00:58:30",
      pos: { type: "Point", coordinates: [-75.09, -10.24] },
      pro: 132,
      mag: 4,
      val: "20200618_005830",
      inte: "--",
      num: 20200428,
      ref: "49 km al N de Madrigal, Caylloma - Arequipa"
    }
  ]
};
export const getGeodata = {
  getEventos: async function(year, mes, paginacion = -1) {
    let cabecera = [
      { label: "Eventos", skill: ["text"], asset: "", prefix: "", sufix: "" }
    ];
    let options = {
      method: "POST",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/breadcrumbevents`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        
      },
      data: { year, mes, paginacion }
    };
    try {
      let res = await axios(options);
      return { Cabecera: cabecera, Datos: res.data.events };
    } catch (error) {
      return { Cabecera: cabecera, Datos: fakeEventos.events };
    }
  },

  getEstaciones: async function(datetime) {

    let cabecera = [
      { label: "Estación", skill: ["text"], asset: "", prefix: "", sufix: "" },
      { label: "Código", skill: ["text"], asset: "", prefix: "", sufix: "" },
      { label: "Ubicación", skill: ["text"], asset: "", prefix: "", sufix: "" },
      { label: "Datos", skill: ["text"], asset: "", prefix: "", sufix: "" }
    ];
    let options = {
      method: "POST",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/breadcrumbstations2`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        "Access-Control-Allow-Credentials": true
      },
      data: { datetime }
    };

    try {
      let res = await axios(options);
      return { Cabecera: cabecera, Datos: res.data };
    } catch (error) {
      return { Cabecera: cabecera, Datos: fakeStations };
    }
  },
  getTabla: eventosTabla,
  getReportes: async function(data) {
    let cabecera = [
      {
        label: "Nombre del archivo",
        skill: ["text"],
        asset: "",
        prefix: "",
        sufix: ""
      },
      {
        label: "Referencia",
        skill: ["text"],
        asset: "",
        prefix: "",
        sufix: ""
      },
      {
        label: "Fecha y hora (local)",
        skill: ["text"],
        asset: "",
        prefix: "",
        sufix: ""
      },
      { label: "Magnitud", skill: ["text"], asset: "", prefix: "", sufix: "" },
      { label: "Descargas", skill: ["text"], asset: "", prefix: "", sufix: "" }
    ];
    let options = {
      method: "POST",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/reportes2`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        "Access-Control-Allow-Credentials": true
      },
      data
    };
    try {
      let res = await axios(options);
      return { Cabecera: cabecera, Datos: res.data };
    } catch (error) {
      let reportes = [
        {
          _id: "5fae0f0a9a0dc55ec85590d3",
          fechaHora: { $date: { $numberLong: "1605242293000" } },
          numeroReporte: 20200700,
          referencia: "22 km al SO de Yauca, Caraveli - Arequipa",
          magnitud: 4.5
        }
      ];
      return { Cabecera: cabecera, Datos: reportes };
    }
  },
  getEdificios: async function() {
    let cabecera = [
      {
        label: "Propietario",
        skill: ["text"],
        asset: "",
        prefix: "",
        sufix: ""
      },
      { label: "Código", skill: ["text"], asset: "", prefix: "", sufix: "" },
      {
        label: "Ubicación",
        skill: ["geoJSON"],
        asset:
          "La latitud, nos indica la distancia angular entre la línea ecuatorial y un punto cualquiera sobre la Tierra. Define una de las coordenadas en grados del epicentro. La longitud, indica la distancia angular entre un punto cualquiera sobre la superficie de la Tierra y el meridiano que se tome como 0°. Define una de las coordenadas en grados del epicentro.",
        prefix: "",
        sufix: ""
      }
    ];
    let options = {
      method: "POST",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/builds`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        "Access-Control-Allow-Credentials": true
      }
    };
    try {
      let res = await axios(options);
      return { Datos: res.data.edificios, Cabecera: cabecera };
    } catch (error) {
      let fakeBuilds = {
        edificios: [
          {
            cert: "011-IGP/2019",
            pos: { type: "Point", coordinates: [-76.99, -12.105] },
            nom:
              "FONDO DE INVERSI\u00d3N EN BIENES RA\u00cdCES LARRAIN VIAL  COLLIERS II-FI",
            cod: "BO05N",
            con: 0
          },
          {
            cert: "010-IGP/2019",
            pos: { type: "Point", coordinates: [-77.1216, -12.0626] },
            nom: "CONSORCIO SACYR - SACEEM II   ",
            cod: "BE01N",
            con: 0
          },
          {
            cert: "010-IGP/2019",
            pos: { type: "Point", coordinates: [-77.1216, -12.0626] },
            nom: "CONSORCIO SACYR - SACEEM II   ",
            cod: "BE01N",
            con: 0
          },
          {
            cert: "009-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0335, -12.08] },
            nom: "INGENIERIA DE LA CONSTRUCCI\u00d3N S.A.C.",
            cod: "LC05N",
            con: 15
          },
          {
            cert: "007-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0261, -12.1211] },
            nom: "INVERSIONES ARAMIS SAC",
            cod: "MF10N",
            con: 23
          },
          {
            cert: "006-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0364, -12.0769] },
            nom: "FT CONSTRUCTORES S.A.C.",
            cod: "LC04N",
            con: 0
          },
          {
            cert: "005-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0625, -12.0994] },
            nom: "CONSTRUCTORA FRANCO SRL",
            cod: "MM02N",
            con: 0
          },
          {
            cert: "004-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0286, -12.0942] },
            nom: "BANCO SANTANDER PER\u00da S.A",
            cod: "SI28N",
            con: 0
          },
          {
            cert: "003-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0006, -12.0896] },
            nom: "BANCO DE LA NACI\u00d3N ",
            cod: "BO04N",
            con: 44
          },
          {
            cert: "002-IGP/2019",
            pos: { type: "Point", coordinates: [-77.0459, -12.0674] },
            nom: "URBANA PER\u00da",
            cod: "JM03N",
            con: 0
          },
          {
            cert: "001-IGP/2019",
            pos: { type: "Point", coordinates: [-76.9817, -12.0963] },
            nom: "CONSTRUCTORA E INMOBILIARIA NICOLE&SEBASTIAN JERI S.A.C.",
            cod: "BO03N",
            con: 0
          }
        ]
      };
      return { Datos: fakeBuilds.edificios, Cabecera: cabecera };
    }
  },
  getEventosE030: async function(cod) {
    let options = {
      method: "POST",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/buildsevents`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        "Access-Control-Allow-Credentials": true
      },
      data: { cod }
    };
    try {
      let res = await axios(options);
      console.log("alan debug", res);
      return {
        Datos: res.data.eventos,
        Cabecera: [{ label: "Eventos" }],
        Edificio: res.data["propietario"]
      };
    } catch (error) {
      let fakeEventosE030 = {
        "0": {
          _id: "5d2e5a1dc4839ebd89eb8ff2",
          propietario: "INGENIERIA DE LA CONSTRUCCI\u00d3N S.A.C.",
          codigo: "LC05N",
          posicion: { type: "Point", coordinates: [-77.0335, -12.08] }
        },
        eventos: [
          {
            _id: "5e0b530022830502427a8569",
            fechaHora: { $date: { $numberLong: "1575516198000" } },
            posicion: { type: "Point", coordinates: ["-76.2927", "-13.8251"] },
            magnitud: "5.3",
            profundidad: "71.4"
          },
          {
            _id: "5e0b52f222830502427a854c",
            fechaHora: { $date: { $numberLong: "1573595252000" } },
            posicion: { type: "Point", coordinates: ["-77.47", "-11.8186"] },
            magnitud: "4.6",
            profundidad: "62.1"
          },
          {
            _id: "5e0b52ee22830577a32583b6",
            fechaHora: { $date: { $numberLong: "1573147121000" } },
            posicion: { type: "Point", coordinates: ["-77.149", "-12.4198"] },
            magnitud: "3.6",
            profundidad: "37.5"
          },
          {
            _id: "5ddeb75222830505621aa1c2",
            fechaHora: { $date: { $numberLong: "1571970957000" } },
            posicion: { type: "Point", coordinates: ["-77.5817", "-11.8631"] },
            magnitud: "4.5",
            profundidad: "47.7"
          },
          {
            _id: "5ddeb76d228305055f31fada",
            fechaHora: { $date: { $numberLong: "1569314433000" } },
            posicion: { type: "Point", coordinates: ["-77.2491", "-12.3863"] },
            magnitud: "3.6",
            profundidad: "45.7"
          },
          {
            _id: "5ddeb76a22830505621aa1dc",
            fechaHora: { $date: { $numberLong: "1566478302000" } },
            posicion: { type: "Point", coordinates: ["-77.0693", "-11.6909"] },
            magnitud: "4",
            profundidad: "87.5"
          },
          {
            _id: "5ddeb76c2283055b2a730e79",
            fechaHora: { $date: { $numberLong: "1564030646000" } },
            posicion: { type: "Point", coordinates: ["-77.6812", "-11.7241"] },
            magnitud: "4",
            profundidad: "25.1"
          },
          {
            _id: "5ddeb76d2283055b2a730e88",
            fechaHora: { $date: { $numberLong: "1561581319000" } },
            posicion: { type: "Point", coordinates: ["-77.3327", "-12.9608"] },
            magnitud: "4.3",
            profundidad: "34.8"
          },
          {
            _id: "5ddeb7722283055b2a730ea0",
            fechaHora: { $date: { $numberLong: "1560932333000" } },
            posicion: { type: "Point", coordinates: ["-77.1783", "-12.4771"] },
            magnitud: "3.6",
            profundidad: "33.3"
          },
          {
            _id: "5ddeb77022830505621aa204",
            fechaHora: { $date: { $numberLong: "1560231468000" } },
            posicion: { type: "Point", coordinates: ["-77.7538", "-11.8029"] },
            magnitud: "4.1",
            profundidad: "43.9"
          },
          {
            _id: "5ddeb7582283055b2a730e5d",
            fechaHora: { $date: { $numberLong: "1559369594000" } },
            posicion: { type: "Point", coordinates: ["-77.3717", "-12.0973"] },
            magnitud: "3.7",
            profundidad: "40.7"
          },
          {
            _id: "5ddeb774228305055f31fb07",
            fechaHora: { $date: { $numberLong: "1559187175000" } },
            posicion: { type: "Point", coordinates: ["-76.4604", "-12.1158"] },
            magnitud: "3.9",
            profundidad: "71.5"
          },
          {
            _id: "5ddeb755228305055f31faa5",
            fechaHora: { $date: { $numberLong: "1559013274000" } },
            posicion: { type: "Point", coordinates: ["-77.598", "-12.4168"] },
            magnitud: "4.8",
            profundidad: "26.8"
          },
          {
            _id: "5ddeb76c22830505621aa1ec",
            fechaHora: { $date: { $numberLong: "1558856476000" } },
            posicion: { type: "Point", coordinates: ["-75.5541", "-5.7369"] },
            magnitud: "8",
            profundidad: "134.7"
          },
          {
            _id: "5ddeb77322830505621aa212",
            fechaHora: { $date: { $numberLong: "1558640796000" } },
            posicion: { type: "Point", coordinates: ["-77.0301", "-12.792"] },
            magnitud: "3.9",
            profundidad: "52.5"
          }
        ]
      };
      return {
        Datos: fakeEventosE030.eventos,
        Cabecera: [{ label: "Eventos" }],
        Edificio: fakeEventosE030["0"]
      };
    }
  },
  getStats: async function(){
    let options = {
      method: "GET",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/stats`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        "Access-Control-Allow-Credentials": true
      },
      data: {}
    };
    try {
      let res = await axios(options);
      return res.data;
    } catch (e) {
      return[{},{},{},{}];
    }
  },
  data: async function() {
    let options = {
      method: "POST",
      url: `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/ran/reportes2`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-OriginOrigin": process.env.VUE_APP_BACKEND_ORIGIN,
        "Access-Control-Allow-Credentials": true
      },
      data: {}
    };

    try {
      let res = await axios(options);
      return res.data;
    } catch (e) {
      return [{}, {}, {}, {}];
    }
    //
  }
  
};
